<template>
  <div id="influencer_custom_request_counter_offer" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" aria-hidden="true">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal">
        
        <!-- Header -->
        <div class="modal-header border-0 pb-0 d-flex align-items-center justify-content-between pt-4 px-4">
          <div class="d-flex align-items-center">
            <h5 class="modal-title text-white font-weight-500 m-0">Custom Request</h5>
            <span class="badge ms-3" style="background: rgba(243, 218, 107, 0.15); color: #F3DA6B; padding: 4px 10px; border-radius: 12px; font-weight: 500;">
              <i class="fa fa-clock me-1"></i> 2 days remaining
            </span>
          </div>
          <button type="button" class="close text-white m-0 p-0" data-dismiss="modal" aria-label="Close" style="opacity: 0.8; outline: none;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        
        <!-- Body -->
        <div class="modal-body text-left pt-4 pb-4 px-4">
          <model-global-message :global-errors="globalErrors" :message="message" @clearMessages="clearMessages()"/>
          
          <div class="mb-4">
            <p class="font-size-12 text-muted mb-1 text-uppercase letter-spacing-1">Subscriber</p>
            <div class="d-flex align-items-center">
              <img src="@/assets/images/stella/no_avatar.png" class="rounded-circle me-2" style="width: 32px; height: 32px; object-fit: cover; border: 1px solid #333;" alt="Avatar">
              <span class="text-white font-size-16 font-weight-500">{{ customRequest.customer ? (customRequest.customer.name || customRequest.customer.username || 'Subscriber') : 'Subscriber' }}</span>
            </div>
          </div>

          <div class="mb-4">
            <p class="font-size-12 text-muted mb-1 text-uppercase letter-spacing-1">Offered Amount</p>
            <h3 class="text-white font-weight-bold m-0">${{ customRequest.counterOfferPrice ? customRequest.counterOfferPrice : customRequest.offerPrice }}</h3>
          </div>

          <div class="mb-2">
            <p class="font-size-12 text-muted mb-1 text-uppercase letter-spacing-1">Request Details</p>
            <div class="text-white font-size-14 p-3" style="background: rgba(255,255,255,0.05); border-radius: 8px; line-height: 1.5; overflow-wrap: break-word;">
              {{desc}}
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-0 d-flex flex-row align-items-center justify-content-between px-4 pb-4 pt-0">
          <!-- Left side: Save for later -->
          <div class="cursor-pointer d-flex align-items-center" @click="saveForLater()" style="opacity: 0.8; transition: all 0.2s;" onmouseover="this.style.opacity='1';" onmouseout="this.style.opacity='0.8';">
            <i class="fa fa-star me-2 font-size-16" :style="customRequest.favorite ? 'color: #F3DA6B;' : 'color: #fff;'"></i>
            <span class="text-white font-weight-500 font-size-14" style="color: white !important;">Save</span>
          </div>

          <!-- Right side: Actions -->
          <div class="d-flex align-items-center">
            <button class="btn button-class-danger text-white m-0 me-2" @click="declineCounterOffer()" style="color: #ff6b6b !important;">
              Decline
            </button>
            <button class="btn button-class2 text-white m-0 me-2" @click="counterOffer()" style="color: white !important;">
              Counter
            </button>
            <button class="btn button-class text-white m-0" @click="acceptCounterOffer()" style="color: white !important;">
              Accept
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {influencerCustomRequestMixin} from "@/mixin/influencer-custom-request-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {clone} from "@/common/Utils";

export default {
  name: "ModelInfluencerCustomRequestCounterOffer",
  mixins: [influencerCustomRequestMixin],
  data() {
    return {
      influencerId: null,
      id: null
    }
  },
  computed: {
    isOptions() {
      return !!this.customRequest.options;
    },
    desc() {
      if (this.isOptions) {
        return this.customRequest.options.title + ' - ' + this.customRequest.requestDescription;
      } else {
        return this.customRequest.requestDescription;
      }
    }
  },
  methods: {
    show(customRequest) {
      this.clearMessages();
      this.customRequest = clone(customRequest);
      this.influencerId = this.customRequest.influencer.id;
      this.id = this.customRequest.id

      $('#influencer_custom_request_counter_offer').modal();
    },
    hide() {
      $('#influencer_custom_request_counter_offer').modal('hide');
    },
    acceptCounterOffer() {

      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.influencerId}/custom-request/${this.id}/accept-offer`;
      this.patchData(url, this.customRequest, (customRequest) => {
        this.$emit("acceptedCustomRequest", customRequest);
      });
    },
    saveForLater() {

      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.influencerId}/custom-request/${this.id}/favorite/true`;
      this.patchData(url, this.customRequest, (customRequest) => {
        this.customRequest = customRequest;
        this.hide();
        this.$emit("saveForLaterCustomRequest", this.customRequest);
      });

    },
    declineCounterOffer() {
      this.hide();
      this.$emit("declineCustomRequest", this.customRequest);
    },
    counterOffer() {
      this.hide();
      this.$emit('counterOffer', this.customRequest);
    }
  }
}
</script>

<style scoped>
.warning-text{
  color: #664d03 !important;
}

.button-class {
    background: linear-gradient(90deg, #F3DA6B 0%, #E53BB9 100%) !important;
    color: white !important;
    border: none !important;
}

.button-class2 {
    background: rgba(255, 255, 255, 0.2) !important;
    color: white !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    border-radius: 8px !important;
}

.button-class2:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    color: white !important;
}

.button-class-danger {
    background: rgba(220, 53, 69, 0.15) !important;
    color: #ff6b6b !important;
    border: 1px solid rgba(220, 53, 69, 0.4) !important;
    border-radius: 8px !important;
}

.button-class-danger:hover {
    background: rgba(220, 53, 69, 0.25) !important;
    color: #ff6b6b !important;
}
</style>
